/*
  BunnyBox verzendklok in de winkelwagen
  - Rekent altijd in Nederlandse tijd (Europe/Amsterdam)
  - Werkdag voor cutoff: aftellen tot cutoff, "vandaag verzonden"
  - Werkdag na cutoff (en morgen is een werkdag): aftellen tot 23:59, "verzending morgen"
  - Weekend, feestdag, vrijdag na cutoff: aftellen tot cutoff op de eerstvolgende werkdag,
    maar bij meer dan 24 uur geen aftelling ("Bestel nu voor verzending op maandag")
  - Nederlandse feestdagen gaan automatisch, extra sluitdagen via thema-instellingen
  - Testen in de preview: voeg ?bb_sim=2026-10-02T15:10 toe aan de URL
*/
(function () {
  if (customElements.get('bb-cart-cutoff')) return;

  var DAY = 86400000;
  // Teksten per taal komen uit data-i18n (snippets/bb-cart-cutoff.liquid); dit zijn alleen de standaardwaarden
  var I18N_DEFAULT = {
    days: 'zondag,maandag,dinsdag,woensdag,donderdag,vrijdag,zaterdag',
    months: 'jan,feb,mrt,apr,mei,jun,jul,aug,sep,okt,nov,dec',
    today: 'vandaag', tomorrow: 'morgen', date: '{d} {m}', drop: 'op',
    ud: 'd', uh: 'u', um: 'min', us: 's'
  };
  function reEsc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  // Simulatie voor testen: ?bb_sim=JJJJ-MM-DDTHH:MM
  var simBase = null, simStart = Date.now();
  try {
    var sim = new URLSearchParams(location.search).get('bb_sim');
    if (sim) {
      var p = sim.split(/[-T:]/).map(Number);
      if (p.length >= 5 && !p.some(isNaN)) simBase = Date.UTC(p[0], p[1] - 1, p[2], p[3], p[4], p[5] || 0);
    }
  } catch (e) {}

  // Wandkloktijd in Amsterdam als UTC-getal, zodat rekenen zonder tijdzoneverschuiving kan
  function amsNow() {
    if (simBase !== null) return simBase + (Date.now() - simStart);
    var o = {};
    fmt.formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    var h = o.hour === '24' ? 0 : +o.hour;
    return Date.UTC(+o.year, +o.month - 1, +o.day, h, +o.minute, +o.second);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(t) { var d = new Date(t); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function sod(t) { return Math.floor(t / DAY) * DAY; }

  function easter(Y) {
    var a = Y % 19, b = Math.floor(Y / 100), c = Y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(Y, month - 1, day);
  }

  // Zelfde feestdagen als het bezorg-aftelblok op de productpagina
  var hCache = {};
  function holidays(Y) {
    if (hCache[Y]) return hCache[Y];
    var s = {};
    function add(t) { s[key(t)] = 1; }
    add(Date.UTC(Y, 0, 1));
    add(Date.UTC(Y, 3, new Date(Date.UTC(Y, 3, 27)).getUTCDay() === 0 ? 26 : 27));
    add(Date.UTC(Y, 4, 5));
    add(Date.UTC(Y, 11, 25));
    add(Date.UTC(Y, 11, 26));
    var e = easter(Y);
    [-2, 0, 1, 39, 49, 50].forEach(function (off) { add(e + off * DAY); });
    return (hCache[Y] = s);
  }
  function isHoliday(t) { return !!holidays(new Date(t).getUTCFullYear())[key(t)]; }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  class BbCartCutoff extends HTMLElement {
    connectedCallback() {
      var ds = this.dataset;
      this.ch = parseInt(ds.ch, 10) || 0;
      this.cm = parseInt(ds.cm, 10) || 0;
      this.eveningClock = ds.evening !== 'false';
      this.saturday = ds.saturday !== 'false';
      this.seconds = ds.seconds !== 'false';
      this.closed = {};
      var self = this;
      (ds.closed || '').split(',').forEach(function (raw) {
        var v = raw.trim(), m;
        if ((m = v.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/))) self.closed[m[3] + '-' + pad(+m[2]) + '-' + pad(+m[1])] = 1;
        else if ((m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) self.closed[m[1] + '-' + pad(+m[2]) + '-' + pad(+m[3])] = 1;
      });
      var t = {};
      try { t = JSON.parse(ds.i18n || '{}') || {}; } catch (e) { t = {}; }
      Object.keys(I18N_DEFAULT).forEach(function (k) { if (typeof t[k] !== 'string' || t[k] === '') t[k] = I18N_DEFAULT[k]; });
      t.dayList = t.days.split(',');
      t.monthList = t.months.split(',');
      this.t = t;
      this.dropRe = new RegExp('\\b' + reEsc(t.drop) + ' (<strong>)?(' + reEsc(t.tomorrow) + '|' + reEsc(t.today) + ')', 'g');
      this.mainEl = this.querySelector('[data-bb-main]');
      this.subEl = this.querySelector('[data-bb-sub]');
      this.hH = this.querySelector('[data-hand="h"]');
      this.hM = this.querySelector('[data-hand="m"]');
      this.hS = this.querySelector('[data-hand="s"]');
      this.render();
      this._t = setInterval(function () { self.render(); }, 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }

    isShip(t) { var d = new Date(t).getUTCDay(); return d > 0 && d < 6 && !isHoliday(t) && !this.closed[key(t)]; }
    isDeliver(t) { var d = new Date(t).getUTCDay(); return d > 0 && (d < 6 || (d === 6 && this.saturday)) && !isHoliday(t); }
    nextShip(t) { var x = sod(t) + DAY; while (!this.isShip(x)) x += DAY; return x; }
    nextDeliver(t) { var x = sod(t) + DAY; while (!this.isDeliver(x)) x += DAY; return x; }

    label(target, today) {
      var diff = Math.round((sod(target) - sod(today)) / DAY);
      var t = this.t;
      if (diff === 0) return t.today;
      if (diff === 1) return t.tomorrow;
      var d = new Date(target);
      if (diff < 7) return t.dayList[d.getUTCDay()] || '';
      return t.date.split('{d}').join(String(d.getUTCDate())).split('{m}').join(t.monthList[d.getUTCMonth()] || '');
    }

    dur(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var nb = ' ', t = this.t;
      if (d > 0) return d + nb + t.ud + ' ' + h + nb + t.uh;
      if (h > 0) return h + nb + t.uh + ' ' + m + nb + t.um;
      if (this.seconds) return m + nb + t.um + ' ' + pad(sec) + nb + t.us;
      return Math.max(1, m) + nb + t.um;
    }

    fill(tpl, map) {
      var out = esc(tpl || '');
      Object.keys(map).forEach(function (k) {
        var val = esc(map[k]);
        var bold = k === 'tijd' || k === 'verzenddag';
        out = out.split('{' + k + '}').join(bold ? '<strong>' + val + '</strong>' : val);
      });
      return out;
    }

    render() {
      var now = amsNow();
      var today = sod(now), off = (this.ch * 60 + this.cm) * 60000, cutoffToday = today + off;
      var ds = this.dataset, mode, target, ship;
      if (this.isShip(now) && now < cutoffToday) {
        mode = 'today'; target = cutoffToday; ship = today;
      } else {
        ship = this.nextShip(now);
        if (this.isShip(now) && ship === today + DAY) { mode = 'evening'; target = today + DAY; }
        else { mode = 'weekend'; target = ship + off; }
      }
      var map = {
        tijd: this.dur(target - now),
        verzenddag: this.label(ship, now),
        bezorgdag: this.label(this.nextDeliver(ship), now),
        cutoff: pad(this.ch) + ':' + pad(this.cm)
      };
      var main, sub;
      if (mode === 'today') { main = ds.tToday; sub = ds.sToday; }
      else if (mode === 'evening') { main = this.eveningClock ? ds.tEvening : ds.tEveningNo; sub = ds.sEvening; }
      else { main = (target - now > DAY) ? ds.tFar : ds.tWeekend; sub = ds.sWeekend; }
      this.setAttribute('data-mode', mode);
      // "op morgen" / "op vandaag" lopen niet, dan valt "op" weg (per taal: drop-woord uit data-i18n)
      if (this.mainEl) this.mainEl.innerHTML = this.fill(main, map).replace(this.dropRe, '$1$2');
      if (this.subEl) this.subEl.innerHTML = this.fill(sub, map);

      var d = new Date(now), h = d.getUTCHours() % 12, mi = d.getUTCMinutes(), se = d.getUTCSeconds();
      if (this.hH) this.hH.setAttribute('transform', 'rotate(' + (h * 30 + mi * 0.5) + ' 22 22)');
      if (this.hM) this.hM.setAttribute('transform', 'rotate(' + (mi * 6 + se * 0.1) + ' 22 22)');
      if (this.hS) this.hS.setAttribute('transform', 'rotate(' + se * 6 + ' 22 22)');
    }
  }

  customElements.define('bb-cart-cutoff', BbCartCutoff);

  // Opvulblok bij een product: verbergt zichzelf zodra de lade erdoor zou moeten scrollen
  if (!customElements.get('bb-cart-fill')) {
    class BbCartFill extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._check = function () { self.check(); };
        window.addEventListener('resize', this._check);
        // na openen van de lade opnieuw meten
        this._t = setInterval(this._check, 800);
        requestAnimationFrame(this._check);
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this._check);
        clearInterval(this._t);
      }
      check() {
        var box = this.closest('.cart-drawer__content');
        if (!box || !box.clientHeight) return;
        this.hidden = false;
        if (box.scrollHeight > box.clientHeight + 1) this.hidden = true;
      }
    }
    customElements.define('bb-cart-fill', BbCartFill);
  }
})();
